import { render } from "./DocumentsPhotoswipe.vue?vue&type=template&id=1bc54e4e"
import script from "./DocumentsPhotoswipe.vue?vue&type=script&lang=js"
export * from "./DocumentsPhotoswipe.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__